// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { updateHighlightedPaths } from 'redux/modules/projectSummary'

// this takes the list of highlighted paths on the project summay > path summary table
// and removes any ids from this list if the path id is not found in the updateVisiblePathIds

const removeFilteredPathsFromHighlight = () => (dispatch, getState) => {
  const { projectSummary } = getState()
  const highlightedPaths = projectSummary.get('highlightedPaths')
  const visiblePathIds = projectSummary.get('visiblePathIds')

  const filteredHighlightedPaths = highlightedPaths.reduce((a, d, i) => {
    // if this path id, 'd' is a visible path, keep it highlighted,
    // otherwise we'll omit it in the new set of highlighted paths.
    if (~visiblePathIds.indexOf(d)) {
      a.push(d)
    }
    return a
  }, [])

  dispatch(updateHighlightedPaths(filteredHighlightedPaths))
}

export default removeFilteredPathsFromHighlight
